import { ColDef } from 'ag-grid-enterprise';
import { TFunction } from 'i18next';
import { DEFAULT_AMOUNT_COLUMN } from 'routes/HumanResourcesModule/components/HrDataGrid/helpers/defaultColDefs';
import { floatingFilter } from 'routes/HumanResourcesModule/Settings/HrPositionMapping/helpers/gridHelpers';
import { PayComponentMapping } from 'routes/Mappings/components/PayComponentsTable/helpers/definitions';

const baseColDef = {
    ...floatingFilter,
    sortable: true,
    resizable: true,
    enableRowGroup: true,
};

export const getColDefs = (
    t: TFunction,
    payComponentMapping: PayComponentMapping[],
): ColDef[] => {
    const defaultColumns = [
        {
            headerName: '',
            width: 50,
            minWidth: 50,
            maxWidth: 50,
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            checkboxSelection: true,
            suppressHeaderMenuButton: true,
            suppressSizeToFit: true,
        },
    ];

    return [
        ...defaultColumns,
        {
            field: 'code',
            headerName: t('mappings.wage_type.code'),
            ...baseColDef,
            width: 50,
        },
        {
            field: 'label',
            headerName: t('mappings.wage_type.label'),
            ...baseColDef,
        },
        {
            field: 'nature',
            headerName: t('mappings.wage_type.nature'),
            ...baseColDef,
            enableRowGroup: true,
        },
        {
            ...baseColDef,
            ...DEFAULT_AMOUNT_COLUMN,
            filterValueGetter: (params) => params?.data?.lastYearAmount || 0,
            valueGetter: (params) => params?.data?.lastYearAmount || 0,
            field: 'lastYearAmount',
            headerName: t(
                'humanResources.settings.payComponentMapping.lastYearAmount',
                {
                    previousYear: new Date().getFullYear() - 1,
                },
            ),
        },
        {
            field: 'payComponent',
            headerName: t('humanResources.settings.payComponent'),
            cellRenderer: 'payComponentSelector',
            cellRendererParams: {
                payComponentMapping,
            },
            valueGetter: (params) =>
                payComponentMapping.find(
                    (item) =>
                        item.destinationId === params?.data?.destinationId,
                )?.value,
            ...baseColDef,
        },
    ];
};
